export enum NumberScale {
  Units = 'units',
  Thousands = 'thousands',
  Millions = 'millions',
}
